var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChequeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.543,
    height: 46.526,
    viewBox: "0 0 76.543 46.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_172705",
    "data-name": "Group 172705",
    transform: "translate(-6317.62 -1995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170468",
    "data-name": "Path 170468",
    d: "M311.079,196.73c.51,4.05.59,17.094.223,32.722v.143l-.064.574-.032.128a14.352,14.352,0,0,1-1.5,4,13.477,13.477,0,0,1-1.627,2.28h46.627V196.746Zm5.948,6.665h23.329v3.189H317.027Zm11.1,26.534-.032-3.189,3.4-.048.032,3.189Zm3.907-16.68H317.027v-3.189h15.006Zm2.71,16.632-.016-3.189,13.283-.048.016,3.189Z",
    transform: "translate(6039.456 1804.935)",
    fill: "#d7dbdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170469",
    "data-name": "Path 170469",
    d: "M188.071,195.9c.2-12.5.067-22.576-.336-25.592a8.835,8.835,0,0,0-2.2-4.991,7.235,7.235,0,0,0-3.014-1.945l-.239-.079-24.27.016L158,197.243l7.369.011v-4h15.724a11.493,11.493,0,0,1,6.983,2.645Z",
    transform: "translate(6159.625 1831.705)",
    fill: "#d7dbdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170470",
    "data-name": "Path 170470",
    d: "M230.318,334.736v.032c0,.319-.016.654-.016.989l-.032.287a10.854,10.854,0,0,1-1.164,3.094,13.391,13.391,0,0,1-2.727,3.827c0,.032-.016,0-.016,0h-15.4V329.6h12.533a7.977,7.977,0,0,1,5.534,2.471,6.342,6.342,0,0,1,.941,1.4,6.549,6.549,0,0,1,.351,1.259Z",
    transform: "translate(6117.218 1698.548)",
    fill: "#cbd0d1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChequeIcon);
export default __webpack_public_path__ + "static/media/chequeIcon.105134d1891705197638b3e478b9fca6.svg";
export { ForwardRef as ReactComponent };